<template>
	<div>
		<p class="order-head"><i class="fa fa-file-text-o" aria-hidden="true"></i> <span>{{ $t("chatMessageOrder.order") }}</span></p>

		<p class="supplier-name">
			<span>{{ message.order_supplier_name }}</span>
		</p>

		<div class="order-text">
			<p class="order-text-title">
				<span>{{ message.timestamp | messageDateFormat }}</span>
			</p>
			<p class="order-text-title">
				<span>{{ $t("chatMessageOrder.deliveryDate") }}:</span>
				<span>{{ message.order_delivery_date }}</span>
			</p>
			<p class="order-text-title">
				<span>{{ $t("chatMessageOrder.productsOrdered") }}:</span>
				<span>{{ message.order_product_count ? message.order_product_count + " ITEMS" : "" }} </span>
			</p>
			<p class="order-text-title">
				<span>{{ $t("chatMessageOrder.productsInclude") }}:</span>
				<span>{{ message.order_product_include }}</span>
			</p>
		</div>
		<div class="order-btn">
			<button @click="handleOrderDetailsVisible">{{ $t("chatMessageOrder.viewOrder") }}</button>
		</div>

		<el-dialog :title="$t('chatMessageOrder.orderDetails')" :visible.sync="orderDetailsVisible" width="40%" :show-close="false" :append-to-body="true">
			<OrderDetails :data="orderDetailsData" />
		</el-dialog>
	</div>
</template>
<script>
import OrderDetails from "./chat-message-order-details.vue";
import { getOrderDetails } from "@/services/api-v2/api-v2";
import moment from "moment";
export default {
	name: "chat-message-order",

	components: {
		OrderDetails,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			// 详情数据
			orderDetailsData: {},

			// 订单详情显示设置
			orderDetailsVisible: false,
		};
	},
	methods: {
		async handleOrderDetailsVisible() {

			try {
				const { data } = await getOrderDetails(this.message.order_id);
				this.orderDetailsData = data;
                this.orderDetailsData.isGroupOrder = false;
                this.orderDetailsData.isNotNextDay = false;

				if (this.message.group_id && this.orderDetailsData.order_by) {
					this.orderDetailsData.isGroupOrder = true;
				}

				if (moment().add(1, 'day').format('YYYY-MM-DD') < this.orderDetailsData.delivery_date) {
					this.orderDetailsData.isNotNextDay = true;
				}

			} catch (error) {
				this.$message.error(error);
			}

			this.orderDetailsVisible = true;
		},
	},
};
</script>

<style lang="less" scoped>
.order-head {
	margin: 0;

	> i {
		font-weight: 500;
		color: black;
		font-size: 16px;
	}
	> span {
		font-weight: 600;
		color: black;
		font-size: 16px;
		margin-left: 3px;
	}
}

.supplier-name {
	font-weight: 600;
	color: black;
	font-size: 14px;
}

.order-text-title {
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;

	> span {
		color: #404040;
		font-weight: 500;
	}
}
.order-btn {
	width: 192px;
	border-top: 1px solid white;
	padding-top: 10px;

	> button {
		padding: 0;
		width: 100%;
		border: 0;
		background: rgba(0, 0, 0, 0);
		font-size: 16px;
		font-weight: 600;
	}
}
</style>
